import React from 'react';
import { Container, Grid, Typography } from '@mui/material';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Trans, useTranslation } from 'react-i18next';

const TermsOfUse = () => {
  const { t } = useTranslation();

  return (
    <>
      <Container>
        <Header />
        <Grid container display='flex' flexDirection='column' sx={{ py: 4, px: { xs: 4, sm: 8, md: 12 }, textAlign: 'justify' }} >
          <Typography variant="h3" sx={{ fontSize: { xs: '2.125rem', sm: '3rem' }, mb: 5, fontWeight: 'bold', textAlign: 'center' }}>
            {t('terms.title')}
          </Typography>

          <Typography variant="body1" paragraph>
            {t('terms.introduction')}
          </Typography>

          <Typography variant="h5" gutterBottom>
            {t('terms.section1.title')}
          </Typography>

          <Typography variant="body1" paragraph>
            <Trans i18nKey="terms.section1.content" components={{ ul: <ul style={{ marginLeft: '1em' }} />, li: <li /> }} />
          </Typography>

          <Typography variant="h5" gutterBottom>
            {t('terms.section2.title')}
          </Typography>

          <Typography variant="body1" paragraph>
            {t('terms.section2.content')}
          </Typography>

          <Typography variant="h5" gutterBottom>
            {t('terms.section3.title')}
          </Typography>

          <Typography variant="body1" paragraph>
            <Trans i18nKey="terms.section3.content" components={{ ul: <ul style={{ marginLeft: '1em' }} />, li: <li /> }} />
          </Typography>

          <Typography variant="body1" paragraph>
            {t('terms.section3.additionalContent')}
          </Typography>

          <Typography variant="h5" gutterBottom>
            {t('terms.section4.title')}
          </Typography>

          <Typography variant="body1" paragraph>
            <Trans i18nKey="terms.section4.content" components={{ ul: <ul style={{ marginLeft: '1em' }} />, li: <li /> }} />
          </Typography>

          <Typography variant="body1" paragraph>
            {t('terms.section4.paymentInfo')}
          </Typography>

          <Typography variant="h5" gutterBottom>
            {t('terms.section5.title')}
          </Typography>

          <Typography variant="body1" paragraph>
            {t('terms.section5.content')}
          </Typography>

          <Typography variant="body1" paragraph>
            {t('terms.section5.userContent')}
          </Typography>

          <Typography variant="h5" gutterBottom>
            {t('terms.section6.title')}
          </Typography>

          <Typography variant="body1" paragraph>
            <Trans i18nKey="terms.section6.content" components={{ ul: <ul style={{ marginLeft: '1em' }} />, li: <li /> }} />
          </Typography>

          <Typography variant="body1" paragraph>
            {t('terms.section6.liabilityLimit')}
          </Typography>

          <Typography variant="h5" gutterBottom>
            {t('terms.section7.title')}
          </Typography>

          <Typography variant="body1" paragraph>
            {t('terms.section7.content')}
          </Typography>

          <Typography variant="h5" gutterBottom>
            {t('terms.section8.title')}
          </Typography>

          <Typography variant="body1" paragraph>
            {t('terms.section8.content')}
          </Typography>

          <Typography variant="h5" gutterBottom>
            {t('terms.section9.title')}
          </Typography>

          <Typography variant="body1" paragraph>
            {t('terms.section9.contactInfo')}
          </Typography>
        </Grid>
      </Container>
      <Footer />
    </>
  );
};

export default TermsOfUse;
